import { render, staticRenderFns } from "./LandingPageCard.vue?vue&type=template&id=9d6ae886&"
import script from "./LandingPageCard.vue?vue&type=script&lang=js&"
export * from "./LandingPageCard.vue?vue&type=script&lang=js&"
import style0 from "./LandingPageCard.vue?vue&type=style&index=0&id=9d6ae886&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports